import { render, staticRenderFns } from "./StdTextMenu.vue?vue&type=template&id=35879b99&"
import script from "./StdTextMenu.vue?vue&type=script&lang=js&"
export * from "./StdTextMenu.vue?vue&type=script&lang=js&"
import style0 from "./StdTextMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StdTextMenu.vue"
export default component.exports